<script lang="ts" setup>
import { computed } from 'vue'
import IconLoading from '@/icons/loading-dots.svg?component'

const props = defineProps<{
  href?: string
  modifiers?: string[]
  disabled?: boolean
  loading?: boolean
  extraAttributes?: Record<string, string>
}>()

const emit = defineEmits<{
  (e: 'click'): void
}>()

const type = computed(() => {
  if (props.href) {
    return 'a'
  } else {
    return 'button'
  }
})

const modifierClasses = computed(() =>
  (props.modifiers || [])
    .map((m) => `Button--${m}`)
    .concat(props.disabled ? ['Button--is-disabled'] : []),
)

const emitClick = function () {
  if (!props.loading && !props.disabled) emit('click')
}
</script>

<template>
  <component
    :is="type"
    :href="href"
    class="Button"
    :class="modifierClasses"
    :disabled="disabled"
    v-bind="extraAttributes"
    @click="emitClick"
  >
    <template v-if="!loading">
      <i v-if="$slots.iconBefore" class="Button__Icon Button__Icon--before">
        <slot name="iconBefore" />
      </i>
      <slot />
      <i v-if="$slots.iconAfter" class="Button__Icon Button__Icon--after">
        <slot name="iconAfter" />
      </i>
    </template>
    <template v-else>
      <span style="visibility: hidden">
        <slot />
      </span>
      <span class="Button__Icon Button__Icon--loading"><icon-loading /></span>
    </template>
  </component>
</template>
